import { i18n } from '../../../i18n-handler/handler/i18n';
import { IStepList } from '../../../interfaces/account/IStepList';

let lang = 'fr';

const getProValidationSteps = (validationStep: number): IStepList => {
    return {
        1: {
            title: `${i18n.t('validation-step.pro.1-title', { lng: lang })}`,
            text: `${i18n.t('validation-step.pro.1-text', { lng: lang })}`,
            actions: {
                COMPLETE: {
                    isAvailable: validationStep === 1,
                    isDisabled: false,
                    title: `${i18n.t('validation-step.pro.1-actions-COMPLETE', { lng: lang })}`,
                },
            },
            isDone: validationStep > 1,
        },
        2: {
            title: `${i18n.t('validation-step.pro.2-title', { lng: lang })}`,
            text: `${i18n.t('validation-step.pro.2-text', { lng: lang })}`,
            actions: {
                COMPLETE: {
                    isAvailable: validationStep === 2,
                    isDisabled: false,
                    title: `${i18n.t('validation-step.pro.2-actions-COMPLETE', { lng: lang })}`,
                },
            },
            isDone: validationStep > 2,
        },
        3: {
            title: `${i18n.t('validation-step.pro.3-title', { lng: lang })}`,
            text: `${i18n.t('validation-step.pro.3-text', { lng: lang })}`,
            actions: {
                COMPLETE: {
                    isAvailable: validationStep === 3,
                    isDisabled: false,
                    title: `${i18n.t('validation-step.pro.3-actions-COMPLETE', { lng: lang })}`,
                },
            },
            isDone: validationStep > 3,
        },
    };
};

export type ProValidationStepsReturn = {
    getProValidationSteps: Function;
};

export const proValidationSteps = (_lang: string): ProValidationStepsReturn => {
    lang = _lang;
    return {
        getProValidationSteps,
    };
};
